/* global __LP_MODAL_ERROR_MAP__ */

/**
 * Gambling: one-language map from `__LP_MODAL_ERROR_MAP__`.
 * Games: full dictionary via `modalError.fallback`.
 */
const modalErrorMap =
    typeof __LP_MODAL_ERROR_MAP__ !== 'undefined'
        ? __LP_MODAL_ERROR_MAP__
        : require('./modalError.fallback').default;

export default modalErrorMap;
